<template>
  <div class="policy-detail-page" style="margin-top: 4rem" id="printableArea" v-if="quote_response">
    <!-- Header with logo -->
    <div class="policy-header">
      <div class="container-fluid">
        <button class="backbuttonTop max-w-md mt-0 mb-5 no-print" @click="backToDashboard()" v-if="!isShow"><img src="/images/backarrow.svg" width="12px" class="selectrtosvg" />BACK TO DASHBOARD</button>
        <div class="d-flex align-items-center justify-content-between flex-wrap">
          <div class="d-flex align-items-center gap-2 policy-logo">
            <img 
              :src="resolveImagePath(quote_response.quote_response_data?.supportingData.insCompanyLogo)"
              alt="Insurance Logo"
              class="insurance-logo"
            />
            <div>
              <span class="policy-company-name">{{ quote_response.quote_response_data?.insuranceAndProducts.insuranceCompanyName.toUpperCase() }}</span>
            </div>
          </div>
          <div class="d-flex no-print gap-2 mt-0 mt-md-0">
            <button class="btn btn-print d-flex gap-2 align-items-center px-md-5 px-3" @click="printDiv('printableArea')">
              <img src="~@/assets/images/printing.png" alt="" width="20" height="20"/>
              <span class="ml-2 pl-2">PRINT</span>
            </button>
            <button
              v-if="this.Policy_status === 'Policy Issued' && !isInvalid(proposal.policy_number)"
              type="button"
              class="btn btn-download d-flex gap-2 align-items-center px-md-4 px-3"
              @click="downloadPolicy()"
            >
              <img class="download-img" src="~@/assets/images/download-dark.png" alt="" width="12" height="16"/><span class="ml-2 pl-2">DOWNLOAD POLICY</span>
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="errorMsgs && (Array.isArray(errorMsgs) ? errorMsgs.length : errorMsgs)"
        class="d-flex justify-content-center mt-3 mb-0 no-print"
      >
        <div class="alert alert-danger mb-0 d-inline-block" role="alert">
          <template v-if="Array.isArray(errorMsgs)">
            <span v-for="(msg, idx) in errorMsgs" :key="idx">{{ msg }}</span>
          </template>
          <span v-else v-html="errorMsgs"></span>
        </div>
      </div>
    </div>

    <!-- Main content area -->
    <div class="container-fluid">
      <!-- Policy Overview Cards -->
      <div class="policy-summary d-flex gap-2 align-items-stretch justify-content-between">
        <div class="policy_summary-content">
          <div class="summary-card d-flex flex-column align-items-start justify-content-center">
            <div class="card-label">JOURNEY ID</div>
            <JourneyIdContainer :journey-id="journey_id" :show-label="false" />
          </div>
        </div>
        <div class="policy_summary-content">
          <div class="summary-card d-flex flex-column align-items-start justify-content-center">
            <div class="card-label">Agent Name</div>
            <div class="card-value">{{ rm_data?.Name }}</div>
          </div>
        </div>
        <div class="policy_summary-content">
          <div class="summary-card d-flex flex-column align-items-start justify-content-center">
            <div class="card-label d-flex align-items-center justify-content-between w-100">
              <p class="card-label mb-0">Policy Status</p>
              <img v-if="Policy_status!='Policy Issued'" src="@/assets/images/sync.png" :title="Policy_status!='Policy Issued' ? 'Click here to check the current status of your policy': ''" width="20" height="20" class="no-print" draggable="false" :class="Policy_status!='Policy Issued' ? 'refresh_button' : ''" @click="refreshPolicy"/>
            </div>
            <div class="card-value" :class="{'pending_status': Policy_status=='Scrutiny', 'success_status': Policy_status=='Policy Issued', 'underwriting_status': Policy_status=='Underwriting'}">{{ Policy_status.toLowerCase()=='scrutiny' ? "INSPECTION REQUIRED" : (Policy_status).toUpperCase() }}</div>
          </div>
        </div>
        <div class="policy_summary-content">
          <div class="summary-card d-flex flex-column align-items-start justify-content-center" v-if="proposalDetails">
            <div class="card-label">Proposal Number</div>
             <CopyToClipboard :hasLabel="false" :copyValue="proposalDetails?.proposal_response?.ManufacturerTracking?.applicationNumber" :checkValid="true" :label="''" :truncate="true"/>
          </div>
        </div>
        <div class="policy_summary-content">
          <div class="summary-card d-flex flex-column align-items-start justify-content-center">
            <div class="card-label">Policy Number</div>
            <CopyToClipboard :hasLabel="false" :copyValue="proposal.policy_number" :checkValid="true" :label="''"/>
            <!-- <div class="card-value">{{ !isInvalid(proposal.policy_number) ? proposal.policy_number : 'NA' }}</div> -->
          </div>
        </div>
      </div>

      <!-- Sum Insured & Premium Details -->
      <div class="premium-details d-flex gap-0 w-100">
        <div class="premium-item border px-0">
          <div class="premium-card">
            <div class="premium-label">PLAN NAME</div>
            <div class="premium-value" style="text-transform: uppercase">{{ quote_response.quote_response_data?.productDetails.planOption?.planName?.toUpperCase() }}</div>
          </div>
        </div>
        <div class="premium-item border px-0">
          <div class="premium-card">
            <div class="premium-label">RTO NAME</div>
            <div class="premium-value" v-if="quoteDetails" style="text-transform: uppercase">{{ quoteDetails?.quote_request_json?.product?.rtoLocationCode?.toUpperCase() }},{{cityName }}</div>
          </div>
        </div>
        <div class="premium-item border px-0">
          <div class="premium-card">
            <div class="premium-label">POLICY HOLDER</div>
            <div class="premium-value">{{ apiReqData.personalInformation.individualDetails[0].ownerBelongsToOrganizationFlag ? "CORPORATE" : 'INDIVIDUAL' }}</div>
          </div>
        </div>
        <div class="premium-item border px-0">
          <div class="premium-card">
            <div class="premium-label">MANUFACTURING YEAR</div>
            <div class="premium-value">{{ apiReqData.product.registrationDetails.manufacturingYear }}</div>
          </div>
        </div>
        <div class="premium-item border px-0">
          <div class="premium-card">
            <div class="premium-label">IDV COVER</div>
            <div class="premium-value" v-if="!(this.apiReqData && this.apiReqData.product.idvDetails.insuredDeclaredValue)">NA</div>
            <div class="premium-value" v-else>{{['StandaloneTP(1)', 'StandaloneTP(3)', 'StandaloneTP(5)'].includes(quote_response.quote_response_data?.insuranceAndProducts.policyType) ? "NA" : "₹ "+formatIndianCurrency(this.apiReqData.product.idvDetails.insuredDeclaredValue) }}</div>
          </div>
        </div>
        <div class="premium-item border px-0">
          <div class="premium-card">
            <div class="premium-label">PACKAGE PREMIUM</div>
            <div class="premium-value">₹ {{currency(quote_response.quote_response_data?.productDetails?.totalPremiumDetails[0]?.totalPremiumValueBeforeTax)}}</div>
          </div>
        </div>
        <div class="premium-item border px-0">
          <div class="premium-card">
            <div class="premium-label">GST @ 18%</div>
            <div class="premium-value">₹ {{formatIndianCurrency(quote_response.quote_response_data?.productDetails?.totalPremiumDetails[0]?.totalTax)}}</div>
          </div>
        </div>
        <div class="premium-item border px-0">
          <div class="premium-card total_premium-card">
            <div class="premium-label">FINAL PREMIUM</div>
            <div class="premium-value">₹ {{formatToINR(quote_response.quote_response_data?.productDetails?.totalPremiumDetails[0]?.totalPremiumWithTax)}}</div>
            <div class="eye-icon">
              <img src="@/assets/images/eyeicon.svg" width="24" height="auto" @click="showBreakupmodal()"/>
              <p>Premium Breakup</p>
            </div>
          </div>
        </div>
      </div>

      <div class="row px-2 mb-4">
        <div class="col-12 policy_details-container p-0">          
          <div class="policy-details-content">
            <div class="policy-details-row">
              <!-- Vehicle Type -->
              <div class="policy-detail-box">
                <p class="detail-label">Vehicle Type</p>
                <p class="detail-value" v-if="apiReqData">{{ apiReqData.product.motorProductType == '4W-Pvt' ? "PRIVATE CAR" : "TWO WHEELER" }}</p>
              </div>

              <!-- Registration Date -->
              <div class="policy-detail-box">
                <p class="detail-label">Registration Date</p>
                <p class="detail-value">{{ formatDateToMonthString(apiReqData.product.registrationDetails.registrationDate) }}</p>
              </div>

              <!-- Car ownership changed in last 12 months -->
              <div class="policy-detail-box">
                <p class="detail-label">Ownership changed in last 12 months?</p>
                <p class="detail-value">{{ apiReqData.quoteCategory=='New' ? 'NA' : apiReqData.personalInformation.individualDetails[0].isOwnerTransfer ? 'YES' : 'NO' }}</p>
              </div>

              <!-- Claim in Previous Policy -->
              <div class="policy-detail-box">
                <p class="detail-label">Claim in Previous Policy?</p>
                <p class="detail-value">{{apiReqData.quoteCategory=='New' ? 'NA' : (apiReqData.product.ncbDetails?.numberOfClaims ? 'YES' : 'NO')}}</p>
              </div>
              
              <!-- Previous NCB -->
              <div class="policy-detail-box">
                <p class="detail-label">Previous NCB %</p>
                <p class="detail-value" v-if="quote_response">{{apiReqData.quoteCategory=='New' ? 'NA' : quote_response.quote_response_data?.insuranceAndProducts.productName.toLowerCase() == 'third party' ? "NA" : apiReqData.product.ncbDetails.ncbPercentageLastYear}}{{apiReqData.quoteCategory=='New' ? '' : quote_response.quote_response_data?.insuranceAndProducts.productName.toLowerCase() == 'third party' ? '' : '%'}}</p>
              </div>

              <!-- Current NCB -->
              <div class="policy-detail-box">
                <p class="detail-label">Current NCB %</p>
                <p class="detail-value" v-if="quote_response">{{ apiReqData.quoteCategory=='New' ? 'NA' : quote_response.quote_response_data?.insuranceAndProducts.productName.toLowerCase() == 'third party' ? "NA" : String(quote_response.quote_response_data?.productDetails?.motorNCBPremium[0].nextNcbSlabDetails[0].nextNcbSlabApplicable).trim()+'%'}}</p>
              </div>

              <!-- Policy Start Date -->
              <div class="policy-detail-box" v-if="proposalDetails">
                <p class="detail-label">Policy Start Date</p>
                <p class="detail-value">{{formatDateToMonthString(proposalDetails?.proposal_response?.policy?.policyStartDate)}}</p>
              </div>
              
              <!-- Policy End Date -->
              <div class="policy-detail-box" v-if="proposalDetails">
                <p class="detail-label">Policy End Date</p>
                <p class="detail-value">{{formatDateToMonthString(proposalDetails?.proposal_response?.policy?.policyEndDate)}}</p>
              </div>
            </div>
            
            <div class="vehicle-details mt-4">
              <h4 class="vehicle-details-title">MAKE/ MODEL/ VARIANT</h4>
              <template v-if="userCarData">
                <div class="vehicle-specs">
                  <div class="vehicle-spec-item" v-if="userCarData.carMake">
                    <span class="spec-dot"></span>
                    <span class="spec-text">{{ userCarData.carMake.makeDescription }}</span>
                  </div>
                  <div class="vehicle-spec-item" v-if="userCarData.model">
                    <span class="spec-dot"></span>
                    <span class="spec-text">{{ userCarData.model.modelDesc }}</span>
                  </div>
                  <div class="vehicle-spec-item" v-if="userCarData.variant">
                    <span class="spec-dot"></span>
                    <span class="spec-text">{{ userCarData.variant.variantDesc.toUpperCase() }}</span>
                  </div>
                  <div class="vehicle-spec-item" v-if="userCarData.fuelType">
                    <span class="spec-dot"></span>
                    <span class="spec-text">{{ userCarData.fuelType.toUpperCase() }}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-card mb-4" v-if="policyInfo && apiReqData?.quoteCategory != 'New'">
          <h3 class="detail-title motor_covers-title border-bottom d-flex align-items-center gap-1"><img src="@/assets/images/plan-name.png" width="32" height="32"/><p class="mb-0">PREVIOUS POLICY DETAILS</p></h3>
          <div class="row">
            <div class="col-md-4 col-sm-6">
              <P class="mb-1 card-label">PREVIOUS POLICY TYPE</P>
              <P class="mb-1 card-label">{{ this.policyInfo?.prevPolicyType || 'NA' }}</P>
            </div>
            <div class="col-md-4 col-sm-6">
              <P class="mb-1 card-label">PREVIOUS INSURER NAME</P>
              <P class="mb-1 card-label">{{ this.policyInfo?.prevPolicyInsurer || 'NA' }}</P>
            </div>
            <div class="col-md-4 col-sm-6">
              <P class="mb-1 card-label">TP INSURER NAME</P>
              <P class="mb-1 card-label">{{ this.policyInfo?.prevPolicyTpInsurer || 'NA' }}</P>
            </div>
          </div>
        </div>

      <!-- Details Section -->
      <div class="policy-details-section">
        <!-- Add-ons Section -->
        <div class="detail-card mb-4" v-if="this.structuredJSON && this.structuredJSON.addOns && this.structuredJSON.addOns.data && this.structuredJSON.addOns.data.length > 0">
          <h3 class="detail-title motor_covers-title border-bottom d-flex align-items-center gap-1"><img src="@/assets/images/motor-shield.png" width="24" height="24"/><p class="mb-0">MOTOR COVERS & DISCOUNTS</p></h3>
          <div class="row">
            <div class="col-md-4 col-sm-6 mb-3" v-for="(addons, index) in quote_response.quote_response_data.productDetails.motorCovers" :key="addons.optionSelected">
              <div class="addon-item d-flex gap-1">
                <img src="@/assets/images/accept.png" width="16" height="16" class="mr-2 pr-2"/>
                <span class="d-flex align-items-center">{{ addons.optionDescription.toUpperCase() }}</span>
                <span v-if="addons.premiumIncludedFlag == 'Yes' || addons.premiumIncludedFlag === '1'" class="d-flex align-items-center">-&nbsp;&nbsp;<span class="px-0 py-1 included_in_plan">INCLUDED IN PLAN</span></span>
              </div>
            </div>
          </div>
        </div>

        <!-- Information Sections -->
        <template v-if="this.structuredJSON && this.structuredJSON.otherRequiredFields">
          <div class="detail-card mb-4" v-for="(details, detailIndex) in filteredStructureJson" :key="detailIndex" v-show="!(apiReqData.quoteCategory === 'New' && details.name=='previousPolicyDetails')">
            <h3 class="detail-title border-bottom mb-2">{{ details.label.toUpperCase() }}</h3>
            
            <template v-if="details.fieldGroups">
              <div v-for="(fieldGroup, groupIndex) in Object.values(details.fieldGroups)" :key="groupIndex">
                <h4 class="detail-subtitle" v-if="displaySubHeading(fieldGroup)">{{ fieldGroup.label.toUpperCase() }}</h4>
                
                <div class="row" v-if="fieldGroup.fields">
                  <div 
                    class="col-md-4 col-sm-6 mb-3" 
                    v-for="field in Object.values(fieldGroup.fields)" 
                    :key="field.id" 
                    v-show="field.input !== '' && (!fullNameExists() || !isNameField(field.label))"
                  >
                    <template v-if="field.input !== '' && (!fullNameExists() || !isNameField(field.label))">
                      <div class="detail-item">
                        <template v-if="field.name === 'rtoCode'">
                          <template v-if="apiReqData.quoteCategory === 'New'">
                            <div class="detail-label">REGISTRATION NUMBER</div>
                            <div class="detail-value" v-if="apiReqData.quoteCategory !== 'New'">
                              {{ Object.values(fieldGroup.fields).find(f => f.name === 'rtoCode')?.input }}
                            </div>
                            <div class="detail-value" v-else>
                              NEW
                            </div>
                          </template>
                        </template>
                        
                        <template v-else-if="field.name === 'vehicleNumber'">
                          <div class="detail-label">REGISTRATION NUMBER</div>
                          <div class="detail-value" v-if="apiReqData.quoteCategory !== 'New'">
                            {{ Object.values(fieldGroup.fields).find(f => f.name === 'rtoCode')?.input }}{{ Object.values(fieldGroup.fields).find(f => f.name === 'vehicleNumber')?.input }}
                          </div>
                          <div class="detail-value" v-else>NEW</div>
                        </template>

                        <template v-else>
                          <div class="detail-label">{{ field.label?.toUpperCase() }}</div>
                          <div class="detail-value">
                            <template v-if="field.type === 'date'">
                              {{ formatDateToMonthString(field.input) }}
                            </template>
                            <template v-else>
                              {{
                                (field.input !== '' && field.input == '0') ? 'NO' :
                                (field.input !== '' && field.input == '1') ? 'YES' :
                                capitalizeFirstLetter(field.input, field.label)
                              }}
                            </template>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>

                <template v-if="fieldGroup.fieldGroups">
                  <div v-for="nestedGroup in Object.values(fieldGroup.fieldGroups)" :key="nestedGroup.id">
                    <h5 class="nested-subtitle" v-if="nestedGroup.input != ''">{{ nestedGroup.label }}</h5>
                    <div class="row">
                      <div class="col-md-4 col-sm-6 mb-3" v-if="nestedGroup.input != ''">
                        <div class="detail-item">
                          <div class="detail-label">{{ nestedGroup.label?.toUpperCase() }}</div>
                          <div class="detail-value">
                            {{
                              (nestedGroup.input != '' && nestedGroup.input == '0') ? 'NO' :
                              (nestedGroup.input != '' && nestedGroup.input == '1') ? 'YES' :
                              capitalizeFirstLetter(nestedGroup.input, nestedGroup.label)
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>

            <div class="row" v-if="details.fields">
              <div 
                class="col-md-4 col-sm-6 mb-3" 
                v-for="field in Object.values(details.fields)" 
                :key="field.id"
                v-show="field.input && field.input !== ''"
              >
                <div class="detail-item">
                  <div class="detail-label">{{ field.label?.toUpperCase() }}</div>
                  <div class="detail-value" v-if="field.type!='date'">
                    {{
                      field.input === '0' ? 'NO' :
                      field.input === '1' ? 'YES' :
                      capitalizeFirstLetter(field.input, field.label)
                    }}
                  </div>
                  <div class="detail-value" v-else>
                    {{formatDateToMonthString(field.input)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="detail-card mb-4" v-if="showGeneratedDocs">
          <h3 class="detail-title border-bottom mb-2">DOCUMENTS</h3>
          <div v-if="pageloading" class="text-center py-3">Loading documents...</div>
          <div v-else>
            <div v-if="displayDocs.length === 0" class="text-muted">No documents found.</div>
            <div v-else class="documents-list">
              <div
                v-for="(doc, idx) in displayDocs"
                :key="(doc.fileName || 'doc') + '-' + idx"
                class="document-row"
              >
                <div class="row g-3 align-items-stretch">
                  <div class="col-md-5 col-sm-12">
                    <div class="document-field-label">File name</div>
                    <div class="document-field-value text-break">{{ doc.fileName || '—' }}</div>
                  </div>
                  <div class="col-md-3 col-sm-6">
                    <div class="document-field-label">Uploaded date</div>
                    <div class="document-field-value">
                      {{ doc.uploadedDate ? formatDateToMonthString(doc.uploadedDate) : '—' }}
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-6">
                    <div class="document-field-label">Status</div>
                    <div class="document-field-value">
                      {{ doc.status != null && String(doc.status).trim() !== '' ? doc.status : '—' }}
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-12 d-flex align-items-end justify-content-md-end">
                    <span
                      v-tooltip.top="'View Document'"
                      class="d-inline-flex align-items-center document-view-action-wrap"
                    >
                      <Button
                        type="button"
                        icon="pi pi-eye"
                        rounded
                        text
                        severity="secondary"
                        :aria-label="'View Document: ' + (doc.fileName || '')"
                        @click="getUploadedFileUrl(doc.filePath)"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modals -->
  <div class="modal fade" id="pollingModal" tabindex="-1" aria-labelledby="pollingModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="pollingModalLabel">Polling Complete</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          The polling process is complete. We have received the data successfully!
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" @click="proceedWithData"
            :disabled="loadingState">Proceed</button>
        </div>
      </div>
    </div>
  </div>
  <OtpVerification v-if="this.otpOpenModalFlag" @close-modal="handleOtpVerifyModal" @resend-otp="resendOtp" :time="time"
    @set-timer="updateTime" @show-error-message="setErrorMessage" />
  <VarificationModal />
  <AmountBreakup v-if="this.openAmountBreakupflag" @emitClose="emitClose()" :selectedPlanData="quote_response.quote_response_data" :journeyId="journeyId"/>
  <Verifypremium v-if="Verifypremiumflag" @emitVerifyClose="VerifymodalClose"
    @emitcontinueNewPremium="continueNewPremium" />
  <pageLoader :msg="loadingMessage" v-if="loadingState || !this.quoteResponseDetails" />
</template>

<script>
import VarificationModal from "@/modals/varificationModal.vue";
//   import OtpVerification from "";
import pageLoader from "../pageLoaders/pageLoader.vue";
import InnerHeaderDiy from "../header/innerHeaderDiy.vue";
import AmountBreakup from "@/modals/amountBreakup.vue";
import ProductDetailsHeader from "../productDetailsHeader/ProductDetailsHeader.vue";
import { getDistributer } from '@/mixins/common';
import Verifypremium from "@/modals/verifypremium.vue";
import backendApi from '@/apis/axios-backend';
import CopyToClipboard from "../uiResuable/CopyToClipBoard.vue"
import Button from 'primevue/button';
import Tooltip from 'primevue/tooltip';
import { stripHtml } from '@/utils/inputSanitizer';

export default {
  components: {
    // OtpVerification,
    VarificationModal,
    pageLoader,
    InnerHeaderDiy,
    AmountBreakup,
    ProductDetailsHeader,
    Verifypremium,
    CopyToClipboard,
    Button,
  },
  // PrimeVue Tooltip overrides global `v-tooltip` (v-tooltip@2 targets Vue 2 / Popper v1 and often fails on PrimeVue 4 controls).
  directives: {
    tooltip: Tooltip,
  },
  mixins: [getDistributer],
  methods: {
    premiumRound(amount){
      return Math.round(amount);
    },
    isInvalid(value) {
      const trimmed = typeof value === 'string' ? value.trim().toLowerCase() : value;
      return (
        trimmed === null ||
        trimmed === undefined ||
        trimmed === false ||
        trimmed === 0 ||
        trimmed === '' ||
        trimmed === 'null' ||
        trimmed === 'undefined' ||
        trimmed === 'false' ||
        (Array.isArray(trimmed) && trimmed.length === 0) ||
        (typeof trimmed === 'object' && !Array.isArray(trimmed) && Object.keys(trimmed).length === 0)
      );
    },
    copyToClipboard(){
      navigator.clipboard.writeText(this.journey_id)
        .then(() => {
          this.copySuccess = true;
          setTimeout(() => {
            this.copySuccess = false;
          }, 2000);
        })
        .catch(err => console.error("Failed to copy text: ", err));
    },
    async checkProposalStatus(journeyId) {
      let qData = [journeyId];
      var headers = {
        "Content-Type": "application/json",
      };

      try {
        const response = await this.backendApi(
          "getProposalStatus",
          qData,
          headers,
          "get"
        );
        this.Policy_status=response.data.data.journey_status;
        this.journeyId=response.data.data.journey_id;
      } catch (error) {
        console.log("Error:", error);
      }
    },
    fullNameExists() {
      return !!this.proposalDetails?.proposal_json?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields 
            && !!this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName?.input?.trim();
    },
    isNameField(label) {
      return ['First Name', 'Middle Name', 'Last Name'].includes(label);
    },
    backToDashboard(){
      this.$router.push('/dashboard');
    },
    printDiv(elementId) {
      console.log("print");
      const content = document.getElementById(elementId).innerHTML;
      const originalContent = document.body.innerHTML;
      document.body.innerHTML = content; 
      window.print(); 
      window.location.reload();
      document.body.innerHTML = originalContent;
    },
    async downloadPolicy() {
      this.errorMsgs = "";
      this.loadingState = true;
      this.loadingMessage = "Downloading the policy.";
      let headers = {};
      let method = "get";
      let reqData = [this.journeyId];

      try {
        const response = await this.backendApi(
          "downloadPolicy",
          reqData,
          headers,
          method
        );
        this.loading2 = false;
        if (response.status == "error") {
          let msg = [response.data.detail];
          this.errorMsgs = msg;
          this.loadingState = false;
        } else if (response?.data?.errors?.length > 0) {
          let msg = [];
          if (this.policyNo && !this.policyPdf.file) {
            msg["0"] =
              "Policy Copy is still not available for Download. Please try after some time.";
          } else if (this.applicationNo && !this.policyNo) {
            msg["0"] =
              "Policy is still with Underwriting. Please try after some time.";
          } else {
            msg["0"] =
              "Policy Copy is still not available for Download. Please try after some time.";
          }
          this.errorMsgs = msg;
          this.loadingState = false;
        } else {
          this.policyPdf = response.data.data;
          this.loadingState = false;
          if (this.policyPdf.file || this.policyPdf.fileName) {
            this.downloadPdf();
          } else {
            const msg = [];
            if (this.policyNo) {
              msg["0"] =
                "Policy Copy is still not available for Download. Please try after some time.";
            } else if (this.applicationNo) {
              msg["0"] =
                "Policy is still with Underwriting. Please try after some time.";
            } else {
              msg["0"] =
                "Policy Copy is still not available for Download. Please try after some time.";
            }
            this.errorMsgs = msg;
          }
        }
      } catch (error) {
        console.log("error msg block : get policy", error);
        this.loadingState = false;
        let msg = ["We are facing some issue while downloading policy"];
        this.errorMsgs = msg;
      }
    },
    downloadPdf() {
      if(this.policyPdf.file){
        const byteCharacters = window.atob(this.policyPdf.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
  
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
  
        // Set the filename dynamically using policy number and a suffix
        const fileName = `Policy_${this.proposal?.policy_number ? this.proposal.policy_number : 'NA'}.pdf`;
  
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.loadingState = false;
      }else if(this.policyPdf.fileName){
        window.open(this.policyPdf.fileName, "_blank");
        this.loadingState = false;
      }
    },

    formatIndianCurrency(num) {
      let [integerPart, decimalPart] = num.toString().split("."); // Split into integer and decimal parts
      let lastThree = integerPart.slice(-3);
      let rest = integerPart.slice(0, -3);

      if (rest !== '') {
          rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
      }
      let formattedDecimal = decimalPart ? "." + parseFloat("0." + decimalPart).toFixed(2).split(".")[1] : "";
      return rest !== '' ? rest + ',' + lastThree + formattedDecimal : lastThree + formattedDecimal;
    },
    refreshPolicy(){
    if(this.Policy_status !='Policy Issued'){
      this.getProposalStatus();
    }
    },
    getVehiclemake(){
      let quoteRequest = JSON.parse(sessionStorage.getItem("quote_request"));
      let vehicleType = quoteRequest.product.motorProductType == '4W-Pvt' ? 1 : 2;
      this.policyHolder = quoteRequest.personalInformation.individualDetails[0].ownerBelongsToOrganizationFlag ? 'Corporate' : 'Individual';
      let reqBody= {
        category: "vehicle",
        vehicleType: vehicleType
      }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ this.$store.state.token}`}, "get", {}, reqBody)
        .then((response) => {
          if(response.data.errors.length > 0) {
            const msg = [];
            if(response.data.errors[0].errorDisplayMsg !=""){
              msg.push(response.data.errors[0].errorDisplayMsg);
            }
          }else if(response && response.data) {  
            let makeModel = response.data.data.make.filter(veh => {              
              return veh.makeCode == quoteRequest.product.vehicleDetails.vehicleMakeCode
            });
            console.log("makeModel", makeModel);
            this.userCarData.carMake = {
              makeCode : makeModel[0].makeCode,
              makeDescription : makeModel[0].makeDescription
            }
            this.getVehicleModel();                        
          }
      })
    },
    getVehicleModel(){
      let quoteRequest = JSON.parse(sessionStorage.getItem("quote_request"));
      let vehicleType = quoteRequest.product.motorProductType == '4W-Pvt' ? 1 : 2;
      let reqBody= {
        category: "vehicle",
        vehicleType: vehicleType,
        make: quoteRequest.product.vehicleDetails.vehicleMakeCode
      }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ this.$store.state.token}`}, "get", {}, reqBody)
        .then((response) => {
          if(response.data.errors.length > 0) {
            const msg = [];
            if(response.data.errors[0].errorDisplayMsg !=""){
              msg.push(response.data.errors[0].errorDisplayMsg);
            }
          } else if(response && response.data) {  
            let makeModel = response.data.data.model.filter(veh => {              
              return veh.modelCode == quoteRequest.product.vehicleDetails.vehicleModelCode;
            });
            this.userCarData.model = {
              modelCode : makeModel[0]?.modelCode || null,
              modelDesc : makeModel[0]?.modelDesc || null
            };
            this.getVehicleVariant();
          }
        });
    },
    getPolicyInfo(){
      let selectedPlanData = JSON.parse(sessionStorage.getItem("selected_plan_data"));
      let quoteRequestPayload = JSON.parse(sessionStorage.getItem("quote_request"));

      let policyTypeList = this.motorProductType=='4W-Pvt' ? this.$store.state.configData?.PREVIOUS_POLICY_TYPE?.PRPOLTYP : this.$store.state.configData?.PREVIOUS_POLICY_TYPE?.PRPOLTYP2;
      let insurerList = this.$store.state.configData?.PREVIOUS_INSURER_LIST;

      let prevPolicyType = quoteRequestPayload?.product?.previousPolicyDetails?.previousCoverageType || selectedPlanData?.productDetails?.previousPolicyDetails?.previousCoverageType;
      let prevPolicyInsurer = quoteRequestPayload?.product?.previousPolicyDetails?.previousPolicyInsurer || selectedPlanData?.productDetails?.previousPolicyDetails?.previousCoverageType;
      let prevPolicyTpInsurer = quoteRequestPayload?.product?.previousPolicyDetails?.previousPolicyTpInsurer || selectedPlanData?.productDetails?.previousPolicyDetails?.previousCoverageType;
      this.policyInfo = {};

      this.policyInfo.prevPolicyType = policyTypeList.find(policy => policy.VALUE == prevPolicyType)?.NAME?.toLowerCase().replace('policy', '')?.toUpperCase();
      this.policyInfo.prevPolicyInsurer = prevPolicyInsurer?.toUpperCase();
      this.policyInfo.prevPolicyTpInsurer = prevPolicyTpInsurer?.toUpperCase();
    },
    getVehicleVariant(){
      let quoteRequest = JSON.parse(sessionStorage.getItem("quote_request"));
      let vehicleType = quoteRequest.product.motorProductType == '4W-Pvt' ? 1 : 2;
      let fuelType = quoteRequest.product.vehicleDetails.vehicleFuelType;
      let reqBody= {
        category: "vehicle",
        vehicleType: vehicleType,
        make: this.userCarData.carMake.makeCode,
        model: this.userCarData.model.modelCode,
        fuelType: fuelType
      }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ this.$store.state.token}`}, "get", {}, reqBody)
        .then((response) => {
          if(response.data.errors.length > 0) {
            const msg = [];
            if(response.data.errors[0].errorDisplayMsg !=""){
              msg.push(response.data.errors[0].errorDisplayMsg);
            }
          } else if(response && response.data) {  
            let makeModel = response.data.data.variant.filter(veh => {           
              return veh.variantCode == quoteRequest.product.vehicleDetails.vehicleVariantCode;
            });
            this.userCarData.variant = {
              variantCode : makeModel[0]?.variantCode || null,
              variantDesc : makeModel[0]?.variantDesc || null
            };
            this.userCarData.fuelType = quoteRequest.product.vehicleDetails.vehicleFuelType

            this.userCarData.RegDate = quoteRequest.product.registrationDetails.registrationDate;
          }
        });
    },
    getCity(){
      let quoteRequest = JSON.parse(sessionStorage.getItem("quote_request"));
      let rtoCode = quoteRequest.product.rtoLocationCode
      let reqBody= {
        category: "rto",
        rtoCode:rtoCode
      }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ this.$store.state.token}`}, "get", {}, reqBody)
        .then((response) => {
          if(response.data.errors.length > 0) {
            const msg = [];
            if(response.data.errors[0].errorDisplayMsg !=""){
              msg.push(response.data.errors[0].errorDisplayMsg);
            }
          } else if(response && response.data) {  
            this.cityName=response.data?.data?.rto[0]?.city ; 
          }
        });
    },
    
    resolveImagePath(variable) {
      return variable || "";
    },
    VerifymodalClose() {
      this.Verifypremiumflag = false;
    },
    continueNewPremium() {
      this.Verifypremiumflag = false;
      this.updateProposalStatus(11);
    },
    compareValues(dataArray, dataObject) {
      for (const item of dataArray) {
        const proposalValue = this.getValueFromPath(dataObject, item.proposalPath);
        const singleQuoteValue = this.getValueFromPath(dataObject, item.singleQuotePath);

        if (proposalValue !== singleQuoteValue) {
          console.log("proposalValue ", proposalValue, singleQuoteValue);
          this.Sqflag = true;
          if (this.Sqflag) {
            // this.getSingleQuote()
          }
          break;
        }
      }
      if (!this.Sqflag) {
        this.updateProposalStatus(11)
      }
      console.log("sqflag", this.Sqflag)
    },
    formatDateToMonthString(dateStr) {
      if (!dateStr) return 'NA';
      let date;
      if (dateStr.includes('/')) {
        const [day, month, year] = dateStr.split('/').map(Number);
        date = new Date(year, month - 1, day);
      } else if (dateStr.includes('-') && dateStr.length === 10) {
        const [year, month, day] = dateStr.split('-').map(Number);
        date = new Date(year, month - 1, day);
      } else {
        date = new Date(dateStr);
      }
      if (isNaN(date.getTime())) return 'NA';
      const day = date.getDate().toString().padStart(2, '0');
      const shortMonth = date.toLocaleString('en-US', { month: 'short' });
      const year = date.getFullYear();
      return `${day}-${shortMonth}-${year}`.toUpperCase();
    },
    getValueFromPath(object, path) {
      return path.split('.').reduce((acc, key) => acc && acc[key], object);
    },
    getCkycDetails() {
      this.loadingState = true;
      this.loadingMsg = "Fetching CKYC Details"
      var self = this;
      // this.loading = true;
      this.kycRedirectUrl = "";
      this.msg = [];

      let reqData = {
        "personalInformation": {
          "dateOfBirth": this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input,
          "email": "",
          "mobileNumber": this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.mobileNumber.input,
          "zipCode": this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input,
          "pan": this.PANNumber,
          //Gender For Testing
          "gender": "male"
        },
        "product": {
          "insuranceCompanyCode": this.selectedPlan.insuranceAndProducts.insuranceCompanyCode,
          "productId": this.selectedPlan.insuranceAndProducts.productCode,
        },
        "trackInfo": {
          "manufacturerQuoteID": this.uniqueQuoteId.toString(),
          "manuApplicationNo": "",
          "KYCRequestID": ""
        },
        "distributor": {
          "distributorID": this.distributorID,
          "agentID": this.getAgentIdFromRmData(this.rmData),
          "salesChannel": "online",
          "channelType": rmData.RoleId !=="1" ? "B2B" : "B2C",
        },
        "kycInfo": {
          "ReturnURL": "https://www.1silvebullet.tech"
        },
        "journey_id": this.journey_id,
      };

      // Save request json  
      //sessionStorage.setItem("request_json", JSON.stringify(reqData));
      let headers = { "Authorization": `Bearer ${this.$store.state.token}` };
      console.log('calling kyc...')
      this.backendApi("getCkyc", reqData, headers)
        .then((response) => {
          this.loadingState = false;

          this.kycResponse = response?.data?.data;
          this.kycStatus = this.kycResponse?.kycInfo?.Status;

          if (response.data.errors.length > 0) {
            for (let i = 0; i < response.data.errors.length; i++) {
              this.msg.push('Verify that your PAN-Date of Birth combination is correct and try again. If the issue continues, please contact the support staff.');
            }
          } else if (this.kycStatus == "approved") {
            this.loadingState = false;
            if (this.newsqData.productDetails.totalPremiumDetails[0].totalPremiumWithTax !== this.quoteResponseDetails.quote_response_data.productDetails.totalPremiumDetails[0].totalPremiumWithTax) {
              this.Verifypremiumflag = true;
            }
            else {
              this.updateProposalStatus(11);
            }
            // this.$router.push({ path: '/process-wizard' })
            sessionStorage.setItem("kyc_response", JSON.stringify(this.kycResponse));
            // let userData = JSON.parse(sessionStorage.getItem("userData")); 
            // setTimeout(function() { 
            //   self.$router.push("/process-wizard");
            // }, 2000);            
          } else if (response.data.data.kycInfo.Status == null && response.data.data.kycInfo.RedirectURL == null) {

            // this.getCkycDetails2();

          } else if ((this.kycStatus == "Pending" || this.kycStatus == "POAIncomplete" || this.kycStatus == "Incomplete")) {
            this.isUploadDocRequired = true;
          } else {
            sessionStorage.removeItem('kyc_response');
            this.kycRedirectUrl = this.kycResponse.kycInfo.RedirectURL;
            setTimeout(function () {
              window.open(self.kycRedirectUrl, '_blank').focus();
            }, 2000);
          }

        })
        .catch((error) => {
          console.log('error msg block : get kyc', error);
          self.loading = false;
        });
    },
    getSingleQuote() {
      // var self = this;
      // self.loading2 = true;
      this.loadingState = true;
      this.loadingMessage = "Submitting Proposal to insurer… Please wait"
      console.log("this.requestBody", this.apiReqData)
      sessionStorage.setItem("quote_request", JSON.stringify(this.apiReqData));
      this.backendApi("quotationApi", this.apiReqData, { "Authorization": `Bearer ${this.$store.state.token}` }, "post")
        .then((response) => {
          console.log("inside response sq")
          if (response.data.errors.length > 0) {
            // this.loading = false;
            this.loadingState = false;

            const msg = [];
            for (let i = 0; i < response.data.errors.length; i++) {
              msg.push(stripHtml(response.data.errors[i]["errorDisplayMessage"]))
            }
            console.log("Errors in Response", msg)
            this.$router.push({ path: '/error-page', query: { backUrl: 'policy-quote', msg: msg } });
          } else if (response && response.data) {

            this.requestId = response.data.reqId;
            // this.loading = false;
            if (response?.data?.data?.quote?.length > 0) {
              console.log("inside loop for")
              this.responseData.push(response.data.data.quote)
            }
            if (response.data.errors.length == 0) {
              const self = this;
              setTimeout(function () {
                self.pollapiflag = true;
                self.pollData();
              }, 1000);

            }
            else {
              console.log("inside else case")
              this.loadingState = false;
              // this.loading2 = false;
              if (this.responseData.length == 0) {
                this.erMsg = 'No products found as per your selected filter. Please change the filters.';
                // self.beforeDestroy();
              }
            }
          }

        }).catch((error) => {
          console.log('error msg block dp', error);
          const msg = "Service is Unavailable, Please try again later.";
          this.$router.push({ path: '/error-page', query: { backUrl: 'policy-quote', msg: msg } });
        })
    },
    async getMotorProduct() {
      // this.loading2 = true;
      this.loadingState = true;
      const startTime = Date.now();
      const maxPollingTime = 3 * 60 * 1000;
      let headers = { "Authorization": `Bearer ${this.$store.state.token}` };
      let reqData = [this.requestId];

      while (this.pollapiflag && (Date.now() - startTime) < maxPollingTime) {
        try {
          // if(this.$route.path !== "/policy-details"){
          //   this.pollapiflag = false;
          //   break;
          // }
          const response = await this.backendApi("quotationPoll", reqData, headers, "get");
          if (response.data.errors.length > 0) {
            this.loading = false;
            this.loadingState = false;
            const msg = [];
            for (let i = 0; i < response.data.errors.length; i++) {
              msg.push(stripHtml(response.data.errors[i]["errorDisplayMessage"]))
            }
            this.$router.push({ path: '/error-page', query: { backUrl: 'policy-quote', msg: msg } });
          }
          if (response?.data?.data?.quote?.length > 0) {
            // this.loading2 = false;
            this.loadingState = false;
            this.suggestedIDV = response?.data?.data?.quote[0].supportingData.insuredDeclaredValue.suggestedIDV;
            this.responseData = response.data.data.quote;
            sessionStorage.setItem("quoteSingleData", JSON.stringify(this.responseData))
          }
          if (response.data.data.isPollComplete == true) {
            this.loadingState = false;
            this.pollapiflag = false;
            this.uniqueQuoteId = response.data.data.quote[0].trackInfo.manufacturerQuoteID;
            this.newsqData = response.data.data.quote[0];
            sessionStorage.setItem("updated_premium", JSON.stringify(this.newsqData));
            this.getCkycDetails();
            this.loading2 = false;
            // this.beforeDestroy();
            break;
          }
          if (response.data.errors.length > 0) {
            if (response.data.errors[0].errorIdentifier == "INVALID_REQUEST_ID") {
              this.pollapiflag = true;
            }
          }
          await this.sleep(1000);
        } catch (err) {
          console.log('error msg block', err);
          this.loading = false;
        }
      };
      if ((Date.now() - startTime) >= maxPollingTime) {
        this.pollapiflag = false;
        this.loading2 = false;
        this.loading = false;
      }
    },
    pollData() {
      console.log("polling")
      if (this.pollapiflag == true) {
        this.getMotorProduct();
      } else {
        // this.loading2 = false;
        if (this.responseData?.length == 0) {
          this.erMsg = 'No products found as per your selected filter. Please change the filters.';
        }
        // this.beforeDestroy();
      }
    },
    updateProposalStatus(statusid) {
      let qData = {
        "journey_id": this.journey_id,
        "status_id": statusid
      };
      var headers = {
        // "quoteId":this.uiQuoteId,
        Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
        "Content-Type": "application/json",
      };

      this.loadingState = true;
      this.loadingMessage = "Updating Proposal Status"

      this.backendApi("ProposalStatus", qData, headers)
        .then((response) => {
          this.loadingState = false;
          if (response == 'error') {
            self.apiError = true;

          }

          else if (response && response.data) {
            console.log('proposal status updated: ', response.data);
            if (statusid == 11 || statusid == 13) {
              if (response.data.status == "failed") {
                let msg = ['We are facing some issue while sending an e-mail']
                this.$router.push({ path: '/networkalert', query: { backUrl: 'proposal-details-check', msg: msg } });
              }
              else {
                // this.$router.push('/confirm-payment-diy');
              }
            }
          }
        })
        .catch((error) => {
          this.loadingState = false;
          console.log('error msg block email', error);

        });
    },
    beforeDestroy() {
      this.disableButtons = false;
    },
    showBreakupmodal() {
      console.log("clicked-------");
      this.openAmountBreakupflag = true;
    },
    emitClose() {
      this.openAmountBreakupflag = false;
    },
    capitalizeFirstLetter(input, input2) {
      console.log("input, input2", input, input2)
      if(!input) return;
      if (input2 == "Date of Birth" || input2 == "Policy Expiry Date" || input2 == "Previous Policy Expiry Date") {
        const date = new Date(input);
        if (isNaN(date.getTime())) return input; // Return original if invalid date

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
      }
      if(input2 !== 'Email' || input2 !='Occupation'){
        return String(input).toUpperCase();
      }
      if (typeof input !== 'string' || input === '') return input;
      return input.charAt(0).toUpperCase() + input.slice(1);

    },
    currency(amt) {
      const tmpAmt = parseFloat(amt).toFixed(2);
      return tmpAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async getSPDetailsOneSB(man_code) {
      try {
        this.loadingState = true;
        this.loadingMessage = "Getting SP Details...";
        let reqData = [man_code];
        let headers = { "Authorization": `Bearer ${this.$store.state.token}` };

        const response = await this.backendApi("getSPDetailsOneSB", reqData, headers, "get");

        this.loadingState = false;

        if (response === 'error') {
          this.apiError = true;
        } else if (response && response.data) {

          console.log('response sp details: ', response.data);

          if (response.data.status === "failed") {
            // Handle redirection to error page and other necessary actions
            this.$router.push({ path: '/error-page', query: { msg: "SP details not Available" } });
          }

          sessionStorage.setItem("sp_details_data", JSON.stringify(response.data));
        }
      } catch (error) {
        this.loadingState = false;
        console.log('error msg block spdetailOneSB API', error);
        this.$router.push({ path: '/error-page', query: { msg: "SP details not Available" } });
      }
    },
    //get ProposalDetails
    async getProposalById(journey_id) {
      try {
        this.loadingState = true;
        this.loadingMessage = "Getting Proposal Details...";
        let qData = [journey_id, "Proposal Review", "false"];
        let headers = { "Authorization": `Bearer ${this.$store.state.token}` };

        const response = await this.backendApi("getProposalDetails", qData, headers, "get");
        this.quote_response=response.data.data.quote_response;
        this.proposal=response.data.data.proposal;
        this.proposalDetail = response.data.data.quote_response;
        console.log("quote_response",this.quote_response)

        // if (this.channelType && !this.$route.query.response) {


          // if (this.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING) {
            // this.compareValues(this.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING, response.data)
          // }
        // }


        this.apiReqData = response.data.data.quote_request.quote_request_json;
        if (response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input) {
          this.apiReqData.personalInformation.individualDetails[0].firstName = response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input) {
          this.apiReqData.personalInformation.individualDetails[0].middleName = response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input) {
          this.apiReqData.personalInformation.individualDetails[0].lastName = response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.gender.input) {
          this.apiReqData.personalInformation.individualDetails[0].gender = response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.gender.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input) {
          this.apiReqData.personalInformation.individualDetails[0].dateOfBirth = response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input) {
          this.apiReqData.personalInformation.individualDetails[0].email = response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input
        }
        // 
        if (response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyEndDate = response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyInsurer = response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyNumber = response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyOdExpiryDate = response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
        }

        if (response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyInsurer = response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
        }

        if (response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyOdNumber = response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyTpExpiryDate = response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyTpInsurer = response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
        }
        if (response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyTpNumber = response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
        }
        // if (!this.channelType) {
          this.loadingState = false;
        // }

        // console.log("request body",this.apiReqData?.personalInformation?.individualDetails[0]?.dateOfBirth)
        console.log("request body", this.apiReqData)


        this.rm_data=response.data.data.user;
        this.proposalDetails = response.data.data.proposal;
        sessionStorage.setItem("filledData", JSON.stringify(this.proposalDetails.proposal_json));
        sessionStorage.setItem("proposal_ui_id", JSON.stringify(this.proposalDetails.proposal_ui_id));

        this.quoteDetails = response.data.data.quote_request;
        this.userDetails = response.data.data.user;

        sessionStorage.setItem("user_profile", JSON.stringify(this.userDetails));
        sessionStorage.setItem("quote_request", JSON.stringify(this.quoteDetails.quote_request_json));
        this.getVehiclemake();
        this.quoteResponseDetails = response.data.data.quote_response;
        let pln = this.quoteResponseDetails.quote_response_data;
        sessionStorage.setItem("selected_plan_data", JSON.stringify(pln));
        sessionStorage.setItem("selectedPlanForCheckout", JSON.stringify(pln));
        sessionStorage.setItem("journey_id", JSON.stringify(journey_id));
        this.$store.commit("setJourneyId", journey_id);

        if (this.proposalDetails.tag_name) {
          sessionStorage.setItem("filledDataTab", JSON.stringify(this.proposalDetails.tag_name));
          sessionStorage.setItem("currentTab", JSON.stringify(this.proposalDetails.tag_name));
        }
        let spdetail_flag = process.env.VUE_APP_SPDETAIL_ONESB;
        this.restructureJson();
        if (spdetail_flag == 1) {
          if (sessionStorage.getItem("rm_data")) {
            this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
            if (this.rmData['RoleId'] !== "1") {
              await this.getSPDetailsOneSB(this.proposalDetails.insurance_company_code);
            }
          }
        }

      } catch (error) {
        this.loadingState = false;
        console.log("error msg block dp", error);
      }
    },
    restructureJson() {
      console.log("inside restructureJson",);
      let addOnsObject = {
        expanded: true,
        data: this.filteredAddons(this.quoteResponseDetails.quote_response_data.productDetails.motorCovers),
        addOnSelected: []
      }
      this.structuredJSON.addOns = addOnsObject;
      const otherValues = Object.values(this.proposalDetails.proposal_json.fieldGroups)
        .filter(requiredFields => requiredFields.fieldGroups !== undefined)
        .map(item => {
          return {
            ...item,
            expanded: true
          };
        });
      this.structuredJSON.otherRequiredFields = otherValues;

      // document.querySelectorAll('.form-check-input').forEach(element => element.setAttribute('checked', true));
    },
    openOtpVerifyModal() {
      const expiryTimeOfOtp = sessionStorage.getItem("ExpiryTime");
      const now = new Date();

      let expiryDate = null;
      if (expiryTimeOfOtp) {
        expiryDate = new Date(expiryTimeOfOtp);
      }

      if (expiryDate instanceof Date && !isNaN(expiryDate.getTime()) && now <= expiryDate) {
        sessionStorage.setItem("OtpExpiryErrorMessage", JSON.stringify({
          type: "error",
          msg: `OTP is sent, expires at ${new Date(expiryDate).toLocaleTimeString()}`
        }))
        this.otpOpenModalFlag = true;
      } else {
        this.resendOtpFromModal();
      }
    },
    resendOtpFromModal() {
      let companyCode = JSON.parse(sessionStorage.getItem('selected_plan_data'))
      this.loadingState = true,
        this.loadingMessage = "Sending OTP...";
      const reqData = {
        distributor: {
          distributorID: this.distributorID,
          agentID: this.getAgentIdFromRmData(this.rmData),
          agentType: this.rmData.RoleId =="4" ? "POSP" : "",
          salesChannel: "",
          channelType: this.rmData.RoleId !=="1" ? "B2B" : "B2C",
          varFields: [
            {
              fieldName: "",
              fieldValue: ""
            }
          ]
        },
        insuranceCompanyCode: companyCode.insuranceAndProducts.insuranceCompanyCode,
        UITrackingRefNo: "0031b045-d539-483f-974b-b87d33ac1e19",
        OTPDetails: {
          mobileNumber: this.proposalDetails.mobile_number,
          email: this.proposalDetails.emailId
        }
      };
      const headers = { "Authorization": `Bearer ${this.$store.state.token}` };

      this.backendApi("getOtpSend", reqData, headers, "post")
        .then((response) => {
          this.loadingState = false;
          if (response === 'error') {
            this.apiError = true;
          } else if (response && response.data) {
            this.otpVerifyResponse = response.data;
            // sessionStorage.setItem("OtpExpiryErrorMessage", null);
            sessionStorage.setItem("ExpiryTime", new Date(this.otpVerifyResponse.data.ExpiryTime).toISOString());

            const expiryTimeOfOtp = sessionStorage.getItem("ExpiryTime");
            let expiryDate = null;
            if (expiryTimeOfOtp) {
              expiryDate = new Date(expiryTimeOfOtp);
            }
            sessionStorage.setItem("OtpExpiryErrorMessage", JSON.stringify({
              type: "error",
              msg: `OTP is sent, expires at ${new Date(expiryDate).toLocaleTimeString()}`
            }))
            sessionStorage.setItem('otpId', JSON.stringify(this.otpVerifyResponse.data.OTPTransactionId));
            this.otpOpenModalFlag = true;
          } else if (response.data.errors.length > 0) {
            this.errorInProposalSubmission = "";
            let ck = 1;
            response.data.errors.forEach(function (element) {
              this.errorInProposalSubmission += ck + '. ' + stripHtml(element.errorDisplayMessage) + '<br/>';
              ck++;
            });
          }
        })
        .catch((error) => {
          this.loadingState = false;
          console.log(error);
        });
    },
    handleOtpVerifyModal() {
      this.otpOpenModalFlag = false;
    },
    resendOtp() {
      this.resendOtpFromModal();
      this.time = 30;
      this.updateTime();
    },
    updateTime() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      this.timerInterval = setInterval(this.updateCountdown, 1000);
    },
    setErrorMessage(data) {
      let self = this;
      let ck = 1;
      self.errorInProposalSubmission = "";
      data?.errors.forEach(function (element) {
        self.errorInProposalSubmission += ck + '. ' + stripHtml(element.errorDisplayMessage) + '<br/>';
        ck++;
      });
      this.loadingState = false;
      this.otpOpenModalFlag = false;
    },
    updateCountdown() {
      if (this.time > 0) {
        this.time -= 1;
      } else {
        clearInterval(this.timerInterval);
      }
    },
    async getProposalStatus() {
      try {
        this.loadingMessage = "Please wait, Getting Information";
        this.loadingState = true;
        const self = this;
        self.errorMsgs = "";
        const reqData = [this.journey_id];
        const headers = {};
        const response = await this.backendApi("getPolicyStatus", reqData, headers, "get");
        const statusRequestId = response.data.reqId;
        if (response.data.errors && response.data.errors.length > 0) {
          response.data.errors.forEach(function (element, index) {
            self.errorMsgs += (index + 1) + '. ' + stripHtml(element.errorDisplayMessage) + '<br/>';
          });
          this.loadingState = false;
          await this.pollPaymentStatus(statusRequestId);
        } else {
          await this.pollPaymentStatus(statusRequestId);
        }
        this.loadingState = false;
      } catch (error) {
        this.loadingState = false;
        console.error("An error occurred during payment URL polling:", error);
      }
    },

    async pollPaymentStatus(statusRequestId) {
      this.loadingState = true;
      const startTime = Date.now();
      const maxDuration = 3 * 60 * 1000;

      try {
        const reqData = [this.journey_id, statusRequestId];

        while (Date.now() - startTime < maxDuration) {
          const response = await this.backendApi("paymentPollStatus", reqData, {}, "get");
          const responseData = response?.data?.data;
          const errors = response?.data?.errors || [];

          if (errors.length > 0) {
            this.loadingState = false;
            break;
          }

          if (responseData?.isPollComplete) {
            this.proposal.policy_number = responseData.manufacturer[0].product[0].policyDetails.policyNumber;
            sessionStorage.setItem("policyNo", this.proposal.policy_number);
            if (responseData.applicationNumber) {
              sessionStorage.setItem("applicationNumber", JSON.stringify(responseData.applicationNumber));
            } else {
              sessionStorage.setItem("applicationNumber", JSON.stringify(responseData.applicationNo));
            }
            sessionStorage.setItem("policy_status", JSON.stringify(responseData.manufacturer[0].product[0].applicationStatus.applicationStatus));
            sessionStorage.setItem("manufacturer_paymentStatus", JSON.stringify(responseData.manufacturer[0].product[0]));

            const applicationStatus = responseData.manufacturer[0].product[0].applicationStatus.applicationStatus;
            this.Policy_status = applicationStatus;
            await this.checkProposalStatus(this.journey_id);
            this.loadingState = false;
            break;
          }

          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      } catch (error) {
        this.loading = false;
        console.error("Error in pollPaymentStatus:", error);
      }
    },
    displaySubHeading(data) {
      let displayFlag = false;
      if (data.fields) {
        for (let key in data.fields) {
          if (data.fields[key].input && data.fields[key].input !== "") {
            displayFlag = true;
          }
        }
      }
      if (data.fieldGroups) {
        for (let key in data.fieldGroups) {
          if (data.fieldGroups[key].input && data.fieldGroups[key].input.trim() !== "") {
            displayFlag = true;
          }
        }
      }
      return displayFlag;
    },
    // New methods for premium breakdown
    isValidInput(input) {
      const num = Number(input);
      return !isNaN(num) && num !== 0;
    },
    hasAddons(motorCovers) {
      if (!motorCovers || !Array.isArray(motorCovers)) return false;
      return motorCovers.some(cover => 
        cover.inbuiltInPlan === "No" && 
        cover.mandatoryInProduct === "No" && 
        (this.addonShowPremium(cover) > 0 || cover.premiumIncludedFlag === "Yes")
      );
    },
    filteredAddons(motorCovers) {
      if (!motorCovers || !Array.isArray(motorCovers)) return [];
      
      // Return all add-ons that aren't basic/mandatory or discounts
      return motorCovers.filter(cover => 
        // cover.inbuiltInPlan === "No" && 
        // cover.optionSelected !== "tptd" && 
        // cover.optionSelected !== "paUnCvr" && 
        // cover.optionSelected !== "paPdCvr" && 
        // // Filter out discount options
        // cover.optionSelected !== "ncb" &&
        // cover.optionSelected !== "volDed" && 
        // cover.optionSelected !== "autoasso" && 
        // cover.optionSelected !== "antiThft" && 
        // cover.optionSelected !== "payAsDrv" &&
        // Only include if it has a premium value or is included in plan
        (cover.premiumIncludedFlag === "Yes" || 
         (cover.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.premiumValue > 0))
      );
    },
    addonShowPremium(addon) {
      if (addon.premiumIncludedFlag === "Yes") return 0;
      
      if (addon.premiumForEachPolicyTerm && 
          addon.premiumForEachPolicyTerm[0] && 
          addon.premiumForEachPolicyTerm[0].premiumForEachPPO && 
          addon.premiumForEachPolicyTerm[0].premiumForEachPPO[0] && 
          addon.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF && 
          addon.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0]) {
        return Number(addon.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue) || 0;
      }
      
      return 0;
    },
    getDiscounts(motorCovers) {
      if (!motorCovers || !Array.isArray(motorCovers)) return [];
      
      // Get discount items from motorCovers (e.g., voluntary deductible, auto association)
      return motorCovers.filter(cover => 
        (cover.optionSelected === "volDed" || 
         cover.optionSelected === "autoasso" || 
         cover.optionSelected === "antiThft" || 
         cover.optionSelected === "payAsDrv") && 
        cover.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.premiumValue > 0
      );
    },
    async getUploadedFile() {
      try {
        this.pageloading = true;
        const journeyId =
          this.journey_id ||
          (sessionStorage.getItem("journey_id")
            ? JSON.parse(sessionStorage.getItem("journey_id"))
            : null);
        if (!journeyId) {
          this.uploadedFileData = [];
          this.generatedDoc = [];
          this.showGeneratedDocs = true;
          return;
        }

        const qData = [journeyId];
        const headers = {
          Authorization: "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
          "Content-Type": "application/json",
        };

        const response = await this.backendApi("getUploadedFiles", qData, headers, "get");
        const uploadedArr = response?.data?.data?.files?.uploaded || [];
        this.uploadedFileData = uploadedArr.map((file) => ({
          fileName: file.fileName || "Unknown",
          uploadedDate: file.uploadedDate,
          status: file.status,
          filePath: file.filePath || "",
        }));

        const generatedArr = response?.data?.data?.files?.generated || [];
        this.generatedDoc = generatedArr.map((doc) => ({
          fileName: doc.fileName || "Unknown",
          uploadedDate: doc.uploadedDate,
          filePath: doc.filePath || "",
        }));

        this.showGeneratedDocs = true;
      } catch (err) {
        console.error("Error fetching uploaded files:", err);
        this.uploadedFileData = [];
        this.generatedDoc = [];
        this.showGeneratedDocs = true;
      } finally {
        this.pageloading = false;
      }
    },
    async getUploadedFileUrl(path) {
      if (!path) return;
      try {
        const reqData = [path];
        const headers = {};
        const response = await this.backendApi("getUploadedFileUrl", reqData, headers, "get");
        const fileUrl = response?.data?.data?.fileUrl;
        if (fileUrl) {
          window.open(fileUrl, "_blank");
          return;
        }
        console.warn("No fileUrl returned for path:", path);
      } catch (error) {
        console.error("Error getting uploaded file url:", error);
      }
    },
  },
  async mounted() {
    this.distributorID = getDistributer()["distributerID"];
    this.selected_plan_data = JSON.parse(sessionStorage.getItem("selected_plan_data"));
    this.apiReqData = JSON.parse(sessionStorage.getItem("quote_request"));
    this.selectedPlan = JSON.parse(sessionStorage.getItem("selected_plan_data"));
    this.rm_data = JSON.parse(sessionStorage.getItem("rm_data"));
    this.channelType = JSON.parse(sessionStorage.getItem('diy'));
    this.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING = this.$store.state.configData.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING
    if (sessionStorage.getItem("userData")) {
      let userData = JSON.parse(sessionStorage.getItem("userData"));
      this.PANNumber = userData.PANNumber;
    }

    if (sessionStorage.getItem("journey_id")) {
      this.journey_id = JSON.parse(sessionStorage.getItem("journey_id"));
    } else if (this.$route.query.journeyId) {
      this.journey_id = (this.$route.query.journeyId);
    }
    sessionStorage.setItem("journey_id", JSON.stringify(this.journey_id));
    this.loadingState = true;
    await this.getProposalById(this.journey_id);
    await this.checkProposalStatus(this.journey_id);
    await this.getUploadedFile();
    if (sessionStorage.getItem("rm_data")) {
      this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
    }
    this.getPolicyInfo();
    this.getCity();
  },
  data() {
    return {
      quote_response:'',     
      Policy_status:'',
      journeyId: "",
      rm_data:'',
      proposal:'',
      proposalDetail:null,
      copySuccess: false,
      apiReqData: '',
      SQ_CALL_BEFORE_PROPOSAL: null,
      Sqflag: false,
      Verifypremiumflag: false,
      channelType: null,
      selectedPlan: '',
      distributorID: '',
      inspectionLink: "",
      payResponse: "",
      loadingState: false,
      loadingMessage: "",
      time: 30,
      timerInterval: null,
      otpExpiryTime: "",
      journey_id: "",
      otpOpenModalFlag: false,
      otpVerifyResponse: null,
      structuredJSON: {},
      userDetails: {},
      quoteDetails: {},
      proposalDetails: {},
      responseData: [],
      errorInProposalSubmission: "",
      errorMsgs: "",
      openAmountBreakupflag: false,
      PANNumber: '',
      PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING: '',
      userCarData: {},
      vehicleType: "",
      items: [
        {
          rmData: null,
          selected_plan_data: null,
          quote_request: null,
          heading: "Plan Summary",
          BankLogo: "$SBI",
          planType: "Plan Type",
          plan: "₹ 14,560",
          coverType: "IDV Cover",
          cover: "₹13,36,452",
          nestedItems: [
            {
              checkitems: "Zero Paper Claims",
            },
            {
              checkitems: "Spot Claims Upto Rs. 20k",
              carcover: "₹ 14,560",
            },
            {
              checkitems: "28 Cashless Garages",
            },
            {
              checkitems: "Self-Video Claims",
            },
          ],
          premiumAmount: "Premium Amount",
          amount: "₹ 14,560",
          GSTType: "GST @18%",
          GST: "₹ 2620",
          amountTitle: "Total Amount",
          totalAmount: "₹ 17,180",
        },
      ],
      Addon: [
        {
          checkheadings: "Zero Paper Claims",
        },
        {
          checkheadings: "Spot Claims Upto Rs. 20k",
        },
        {
          checkheadings: "28 Cashless Garages",
        },
        {
          checkheadings: "Self-Video Claims",
        },
      ],
      Additions: [
        {
          id: 1,
          accoheading: "Owner Details",

          expanded: true,
          nestedItems: [
            {

              checkContent: "Akash Chopra",
              subcheck: "Name",
            },
            {

              checkContent: "+91 8888 38888",
              subcheck: "Mobile",
            },
            {

              checkContent: "16/04/1986",
              subcheck: "Date Of Birth",
            },
            {

              checkContent: "AUK37878K",
              subcheck: "PAN",
            },
            {

              checkContent: "Male",
              subcheck: "Gender",
            },
            {

              addressContent: "328/330, Mangaldas Market, opposite Jumma Masjid, Mumbai, Maharashtra 400002, India",
              address: "Address",
            },

          ],
        },
        {
          id: 2,
          accoheading: "Vehicle Details",

          expanded: true,
          nestedItems: [
            {

              checkContent: "1887787377",
              subcheck: "Engine Number",
            },
            {

              checkContent: "299898798788",
              subcheck: "Chassis Number",
            },
            {

              checkContent: "Yes",
              subcheck: "Is your vehicle taken on loan?",
            },
            {

              checkContent: "SBI Auto Loan",
              subcheck: "Financier",
            },


          ],
        },
        {
          id: 3,
          accoheading: "Previous Policy Details",

          expanded: true,
          nestedItems: [

            {
              subcontent: "Own Damage Detail",
              checkContent: "SBI",
              subcheck: "Insurer",
            },
            {

              checkContent: "12/06/2025",
              subcheck: "Policy Expiry Date",
            },
            {

              checkContent: "99389898",
              subcheck: "Policy Number",
            },



          ],
        },

      ],
      policyInfo: null,
      cityName:"",
      showGeneratedDocs: false,
      pageloading: false,
      docsLoaded: false,
      generatedDoc: [],
      uploadedFileData: [],
    };
  },
  computed: {
    displayDocs() {
      if (Array.isArray(this.uploadedFileData) && this.uploadedFileData.length > 0) {
        return this.uploadedFileData;
      }
      if (Array.isArray(this.generatedDoc) && this.generatedDoc.length > 0) {
        return this.generatedDoc;
      }
      return [];
    },
    filteredStructureJson() {
      const checkInputValues = (obj) => {
        if (obj.fields) {
          for (let key in obj.fields) {
            if (obj.fields[key].input && obj.fields[key].input.trim() !== "") {
              return true;
            }
          }
        }
        if (obj.fieldGroups) {
          for (let key in obj.fieldGroups) {
            if (checkInputValues(obj.fieldGroups[key])) {
              return true;
            }
          }
        }
        return false;
      };
      return this.structuredJSON.otherRequiredFields && this.structuredJSON.otherRequiredFields.filter(container => checkInputValues(container)).filter(fields => fields.name != 'distributor');
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/components/select-card.scss";
@import "../../assets/scss/components/multi-quotes.scss";
@import "../../assets/scss/components/form-wizard.scss";

.policy-detail-page {
  font-family: $regularFont;
  color: $base-text;
  background-color: #f9f9f9;
  min-height: 100vh;
  padding-bottom: 2rem;
}

/* Header Styles */
.policy-header {
  padding: 15px 0;
  margin-bottom: 25px;
  
  .container-fluid {
    padding: 0 25px;
  }
}

.policy-logo {
  &-figure {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    margin-right: 15px;
  }
}

.insurance-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
  background: $commonColor;
  padding:10px;
  border-radius:10px;
}

.policy-company-name {
  font-size: 14px;
  font-weight: 200;
  color: $heading-color;
  display: block;
}

.policy-type {
  font-size: 14px;
  color: $gray-600;
}

.btn-print, .btn-download {
  background-color: $main-bg;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: darken(#3B39D9, 10%);
    box-shadow: 0 4px 8px rgba(59, 57, 217, 0.25);
  }
  img:not(.download-img){
    filter: invert(1);
  }
}

/* Container Styles */
.container-fluid {
  padding: 0 30px;
}

/* Summary Cards */
.policy-summary {
  margin-bottom: 25px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .policy_summary-content{
    width: calc(20% - 8px);
    min-height: 80px;
    
    .summary-card{
      min-height: 80px;
    }
  }
}
.backbuttonTop {
  display: flex;
  gap: 6px;
  text-align: left;
  font-size: 14px !important;
  padding: 0 !important;
  max-width: 200px;
  background-color: transparent;
  border: none;
  color: $main-bg;
}

.summary-card {
  background-color: white;
  border-radius: 8px;
  padding: 15px 20px;
  height: 100%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border-left: 4px solid $main-bg;
  
  .card-label {
    font-size: 12px !important;
    font-weight: 200;
    color: $gray-600;
    text-transform: uppercase;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
  }
  
  .card-value {
    font-size: 14px !important;
    font-weight: 200;
    color: $heading-color;
  }

  .wizard-hold{
    .copy_container{
      position: relative;
      img{
        width: 20px !important;
        border: none;
      }
      .copy-icon{
        height: 24px !important;
      }
      .success-icon{
        height: 20px !important;
      }
      .copy_tooltip{
        opacity: 0;
        visibility: hidden;
        position: absolute;
        top: -26px;
        left: -12px;
        font-size: 14px;
        color: $commonColor;
        background-color: $cardBackgroundDark;
      }
      &:hover{
        .copy_tooltip{
          visibility: visible;
          opacity: 1;
        }
      }
    }
  }
}

/* Premium Details */
.premium-details {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.premium-item {
  width: 12.5%;
  flex: 0 0 auto;
  transition: all 0.3s ease;
}

.premium-card {
  background-color: $commonColor;
  padding: 15px 20px;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  
  .premium-label {
    font-size: 12px;
    font-weight: 600;
    color: $gray-700;
    margin-bottom: 8px;
  }
  
  .premium-value {
    font-size: 13px;
    font-weight: 700;
    color: $main-bg;
  }
}

/* Date Information */
.policy-dates {
  margin-bottom: 30px;
  
  .date-field {
    background-color: white;
    padding: 10px 20px;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    
    .date-label {
      font-size: 13px;
      font-weight: 300;
      color: $gray-600;
      margin-right: 5px;
    }
    
    .date-value {
      font-size: 13px;
      font-weight: 300;
      color: $heading-color;
    }
  }
}

/* Details Section */
.policy-details-section {
  margin-bottom: 50px;
  
  .section-title {
    font-size: 16px !important;
    font-weight: 200;
    color: $main-bg !important;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid $gray-300;
  }
}
.total_premium-card {
  position: relative;
  .eye-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    z-index: 10;

    &:hover + .show_totalPremium-details,
    & + .show_totalPremium-details:hover {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
    p{
      position: absolute;
      top: -20px;
      right: -16px;
      visibility: hidden;
      opacity: 0;
      width: 120px;
      font-size: 12px;
      background-color: $cardBackgroundDark;
      border-radius: 6px;
      color: $commonColor;
      padding: 4px 8px;
      z-index: 10;
      transition: all 0.3s cubic-bezier(0.215, 0.610, 0.355, 1);
    }
    &:hover{
      p{
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .show_totalPremium-details {
    width: 360px;
    position: absolute;
    bottom: -180px;
    right: 0;
    z-index: 10;
    background: white;
    border: 1px solid #ddd;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 8px 12px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
    max-height: 340px;
    overflow-y: auto;
    
    p{
      font-size: 14px;
    }
    
    /* New styles for premium breakdown */
    .premium-breakdown-title {
      font-size: 13px;
      font-weight: 600;
      color: $main-bg;
      margin-bottom: 8px;
      padding-bottom: 3px;
      border-bottom: 1px solid $gray-200;
    }
    
    span {
      font-size: 12px;
      color: $gray-600;
    }
    
    strong {
      font-size: 12px;
      color: $heading-color;
      font-weight: 600;
    }
    
    .total-premium {
      border-top: 1px solid $gray-200;
      padding-top: 5px;
      margin-top: 5px;
      
      b, strong {
        font-size: 13px;
        font-weight: 700;
        color: $main-bg;
      }
    }
  }
}
.refresh_button{
  cursor: pointer;
  transition: all 0.6s ease-in-out;
  &:hover{
    animation: rotateMe 0.6s ease-in-out forwards;
  }
  @keyframes rotateMe {
    0%{
      transform: rotate(0deg);
    }
    50%{
      transform: rotate(90deg);
    }
    100%{
      transform: rotate(0deg);

    }
  }
}
.btn-download{
  border-radius: 20px;
  border: 1px solid $base-text;
}
.policy_details-container{
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.policy-details-header {
  padding: 0 4px;
  color: $heading-color;
  
  h4 {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
}

.policy-details-content {
  padding: 10px;
}

.policy-details-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  // gap: 10px;
  margin: 0 -5px;
}

.policy-detail-box {
  flex: 1;
  min-width: 150px;
  padding: 15px 10px;
  background-color: $commonColor;
  transition: all 0.3s ease;
  border: 1px solid $table-td;
  
  .detail-label {
    font-size: 12px;
    font-weight: 500;
    color: $gray-600;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .detail-value {
    font-size: 13px;
    font-weight: 600;
    color: $heading-color;
    margin-bottom: 0;
  }
}

.vehicle-details {
  padding-top: 20px;
  
  .vehicle-details-title {
    font-size: 15px;
    font-weight: 600;
    color: $main-bg;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;
  }
}

.vehicle-specs {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 25px;
  padding: 5px 0;
}

.vehicle-spec-item {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .spec-dot {
    width: 8px;
    height: 8px;
    background-color: $main-bg;
    border-radius: 50%;
    flex-shrink: 0;
  }
  
  .spec-text {
    font-size: 14px;
    font-weight: 500;
    color: $heading-color;
  }
}

.detail-card {
  background-color: white;
  border-radius: 8px;
  padding: 20px 25px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  
  .detail-title {
    font-size: 16px;
    font-weight: 700;
    color: $heading-color;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid $gray-200;
  }

  .motor_covers-title{
    color: $main-bg !important;
  }
  
  .detail-subtitle {
    font-size: 14px;
    font-weight: 600;
    color: $main-bg;
    margin: 15px 0 10px;
  }
  
  .nested-subtitle {
    font-size: 13px;
    font-weight: 600;
    color: $gray-700;
    margin: 10px 0 5px;
    font-style: italic;
  }

  .documents-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .document-row {
    border: 1px solid $gray-200;
    border-radius: 8px;
    padding: 16px 18px;
    background-color: #fafafa;
  }

  .document-field-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: $gray-600;
    margin-bottom: 6px;
  }

  .document-field-value {
    font-size: 14px;
    font-weight: 500;
    color: $heading-color;
    min-height: 1.25rem;
  }
}

.detail-item {
  margin-bottom: 5px;
  
  .detail-label {
    font-size: 13px;
    font-weight: 600;
    color: $gray-600;
    margin-bottom: 4px;
  }
  
  .detail-value {
    font-size: 14px;
    font-weight: 500;
    color: $heading-color;
  }
}

.addon-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  
  i {
    color: $verify-color;
    font-size: 16px;
  }
  
  span {
    font-size: 14px;
    font-weight: 500;
  }
  .included_in_plan{
    border-bottom: 1px solid #bdbdbd;
  }
}

/* Enhanced Responsive Styling */
@media (max-width: 1200px) {
  .policy-summary .policy_summary-content {
    width: calc(33.33% - 8px);
  }
  
  .premium-item {
    width: 33.33%;
  }
}

@media (max-width: 991px) {
  .container-fluid {
    padding: 0 15px;
  }
  
  .policy-header {
    .d-flex {
      flex-wrap: wrap;
      gap: 10px;
    }
  }
  
  .policy-summary .policy_summary-content {
    width: calc(50% - 8px);
  }
  
  .premium-item {
    width: 50%;
  }
  
  .policy-detail-box {
    min-width: calc(33.33% - 10px);
  }
  
  .show_totalPremium-details {
    width: 300px;
    right: -70px;
  }
}

@media (max-width: 767px) {
  .policy-header {
    padding-top: 50px;
    .d-flex {
      justify-content: center !important;
    }
    
    .no-print {
      margin-top: 15px;
      width: 100%;
      justify-content: center;
    }
  }
  
  .policy-detail-page {
    margin-top: 2rem !important;
  }
  
  .policy-summary .policy_summary-content {
    width: 100%;
  }
  
  .premium-details {
    flex-direction: column;
  }
  
  .premium-item {
    width: 100%;
  }
  
  .policy-detail-box {
    min-width: 100%;
    margin-bottom: 10px;
  }
  
  .policy-details-row {
    flex-direction: column;
  }
  
  .detail-card {
    padding: 15px;
  }
  
  .row .col-md-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  
  .show_totalPremium-details {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 350px;
    right: auto;
    bottom: auto;
    z-index: 1100;
    
    &:hover {
      transform: translate(-50%, -50%) !important;
    }
  }
}

@media (max-width: 576px) {
  .container-fluid {
    padding: 0 10px;
  }
  
  .policy-logo {
    img {
      height: 40px;
      width: auto;
    }
  }
  
  .btn-print, .btn-download {
    padding: 6px 12px;
    font-size: 12px;
    
    img {
      width: 16px;
      height: 16px;
    }
    
    span {
      font-size: 12px;
    }
  }
  
  .premium-card {
    padding: 12px 15px;
  }
  
  .policy-detail-box {
    padding: 10px;
  }
  
  .vehicle-specs {
    flex-direction: column;
    gap: 8px;
  }
  
  .detail-card {
    padding: 12px;
    
    .detail-title {
      font-size: 14px;
    }

    .motor_covers-title{
      color: $main-bg !important;
    }
    
    .detail-subtitle {
      font-size: 13px;
    }
  }
  
  .detail-item {
    .detail-label {
      font-size: 12px;
    }
    
    .detail-value {
      font-size: 13px;
    }
  }
  
  .addon-item span {
    font-size: 13px;
  }
}

/* Print styles */
@media print {
  /* Reset all browser-specific print styles */
  * {
    -webkit-print-color-adjust: exact !important; /* Chrome, Safari, Edge */
    color-adjust: exact !important; /* Firefox */
    print-color-adjust: exact !important;
  }
  
  html, body {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
  }
  
  .policy-detail-page {
    background-color: #f9f9f9 !important;
    margin: 0;
    padding: 0;
    width: 100%;
    overflow: visible;
  }
  
  .no-print {
    display: none !important;
  }
  
  /* Keep header styling */
  .policy-header {
    padding: 15px 0 !important;
    margin-bottom: 25px !important;
    print-color-adjust: exact !important;
  }
  
  .policy-logo-figure {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
    // background-color: white !important;
  }
  
  /* Summary card styling */
  .summary-card {
    background-color: white !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
    border-left: 4px solid $main-bg !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  
  /* Premium card styling */
  .premium-card {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  
  /* Detail cards */
  
  /* Section title */
  .section-title {
    border-bottom: 1px solid $gray-300 !important;
    page-break-after: avoid !important;
    break-after: avoid !important;
  }
  
  /* Detail items */
  .detail-subtitle {
    color: $main-bg !important;
    page-break-after: avoid !important;
    break-after: avoid !important;
  }
  
  /* Add-on items */
  .addon-item i {
    color: $verify-color !important;
  }
  
  /* Force page breaks where needed */
  .policy-details-section {
    page-break-before: auto !important;
    break-before: auto !important;
  }
  
  /* Avoid breaking inside rows */
  .row {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  
  /* Make sure colors print */
  .policy-company-name, .card-value, .premium-value, .date-value, .detail-title, .detail-value {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  /* Fix for Chrome/Edge */
  @page {
    size: A4 portrait;
    margin: 0.5cm;
  }
}

.dark{
  .policy-detail-page{
    background-color: $text-color;
    .summary-card,
    .premium-card,
    .policy-detail-box,
    .detail-card{
      background-color: $drop_box;
      .card-label{
        color: $base-dark-text;
      }
      .card-value,
      .premium-label,
      .detail-label,
      .detail-value{
        color: $base-dark-text;
      }
    }
    .premium-card{
      border: 1px solid $text-darkColor !important;
    }
    .premium-item{
      border: none !important;
    }
    .policy-company-name{
      color: $base-dark-text;
    }
    .policy-details-header{
      h4{
        color: $base-dark-text;
      }
    }
    .vehicle-specs{
      .spec-text{
        color: $base-dark-text;
      }
    }
    .detail-title{
      color: $base-dark-text;
      border-color: $base-text !important;
    }

    .document-row {
      background-color: $drop_box;
      border-color: $text-darkColor !important;
    }
    .document-field-label {
      color: $base-dark-text !important;
    }
    .document-field-value {
      color: $base-dark-text !important;
    }

    .motor_covers-title{
      color: $main-bg !important;
    }
    .premium-breakdown-title{
      border-color: $base-text !important;
    }
    .show_totalPremium-details{
      background-color: $drop_box;
      border: none !important;
      span,
      strong{
        color: $base-dark-text !important;
      }
    }
  }
  .wizard-hold{
    .journeyId{
      color: $base-dark-text !important;
    }
  }
  .addon-item {
    span {
      color: $text-darkColorTransparent !important;
    }
  }
  .backbuttonTop{
    color: $main-bg !important;
    img{
      filter: invert(1);
    }
  }
}
</style>